module.exports = __webpack_public_path__ + "img/numberly-france.fe13c980.svg";